import styles from './Case3.module.scss'
import { useRef } from 'react'
import Button from 'components/common/Button/Button'
import animationStyles from 'components/common/Animation/Animation.module.scss'
import useElementVisible from 'components/common/Animation/useElementVisible'

export interface CaseDetail3 {
  no: string
  title: string
  sector: string
  imgSrc: string
  alt: string
  background: string
  solution: string
  team1: string
  team2: string
  period: string | JSX.Element
}

export interface CaseItem3 {
  sectionTitle: string
  cases3: CaseDetail3[]
}

interface Props {
  CaseEach3: CaseItem3[]
}

const Case3: React.FC<Props> = ({ CaseEach3 }) => {
  const animeRef = useRef<HTMLDivElement>(null)
  const isVisible = useElementVisible(animeRef, 0.1)

  return (
    <section
      className={`${styles.case} ${animationStyles.fade} ${isVisible ? animationStyles.fadeOn : ''}`}
      ref={animeRef}
    >
      {CaseEach3.map((item, index) => (
        <div key={index}>
          <h2 className={styles.sectionTitle}>{item.sectionTitle}</h2>
          {item.cases3.map((cases3, idx) => (
            <section key={idx} className={styles.caseSec}>
              <div className={styles.caseSec__no}>{cases3.no}</div>
              <div className={styles.caseSec__main}>
                <h3 className={styles.caseSec__main__title}>{cases3.title}</h3>
                <p className={styles.caseSec__main__sector}>{cases3.sector}</p>
                <div className={styles.caseSec__main__cts}>
                  <figure className={styles.caseSec__main__cts__image}>
                    <img src={cases3.imgSrc} alt={cases3.alt} width={380} height={253} />
                  </figure>
                  <div className={styles.textItem}>
                    <dl className={styles.textItem__background}>
                      <dt className={styles.textItem__background__title}>背景</dt>
                      {cases3.background && <dd className={styles.textItem__background__text}>{cases3.background}</dd>}
                    </dl>
                    <dl className={styles.textItem__solution}>
                      <dt className={styles.textItem__solution__title}>ソリューション</dt>
                      {cases3.solution && <dd className={styles.textItem__solution__text}>{cases3.solution}</dd>}
                    </dl>
                    <dl className={styles.textItem__team}>
                      <dt className={styles.textItem__team__title}>体制</dt>
                      {cases3.team1 && <dd className={styles.textItem__team__list}>{cases3.team1}</dd>}
                      {cases3.team2 && <dd className={styles.textItem__team__list}>{cases3.team2}</dd>}
                    </dl>
                    <dl className={styles.textItem__period}>
                      <dt className={styles.textItem__period__title}>期間</dt>
                      {cases3.period && <dd className={styles.textItem__period__text}>{cases3.period}</dd>}
                    </dl>
                  </div>
                </div>
              </div>
            </section>
          ))}
        </div>
      ))}
    </section>
  )
}

export default Case3
